/**
 * Port of {@class CelSuggestion} —
 * backend/src/main/java/com/irian/iam/ruleengine/cel/CelSuggestion.java
 *
 * A single typed suggestion emitted by IamCelSuggestionEngine.
 */

export const Kind = {
    ROOT_KEYWORD: 'ROOT_KEYWORD',
    STATIC_FIELD: 'STATIC_FIELD',
    ATTRIBUTE: 'ATTRIBUTE',
    RELATIONSHIP_ALIAS: 'RELATIONSHIP_ALIAS',
    OPERATOR: 'OPERATOR',
    LOGICAL: 'LOGICAL',
    CLOSER: 'CLOSER',
    VALUE: 'VALUE',
    LIST_MACRO: 'LIST_MACRO',
    STRING_METHOD: 'STRING_METHOD',
    FILTER_FIELD: 'FILTER_FIELD',
} as const
export type Kind = typeof Kind[keyof typeof Kind]

export type Replacement = {
    readonly start: number
    readonly end: number
    readonly text: string
}

export function replacementAtCursor(cursor: number, text: string): Replacement {
    return {start: cursor, end: cursor, text}
}

export function replacementOf(start: number, end: number, text: string): Replacement {
    return {start, end, text}
}

export type CelSuggestion = {
    readonly text: string
    readonly kind: Kind
    readonly valueType: string | null
    readonly description: string | null
    readonly replacement: Replacement | null
}

export function celSuggestion(text: string, kind: Kind, valueType: string | null = null, description: string | null = null, replacement: Replacement | null = null): CelSuggestion {
    return {text, kind, valueType, description, replacement}
}

export function withDescription(s: CelSuggestion, description: string | null): CelSuggestion {
    return {...s, description}
}

export function withReplacement(s: CelSuggestion, replacement: Replacement): CelSuggestion {
    return {...s, replacement}
}

export function replaceStart(s: CelSuggestion): number {
    return s.replacement === null ? -1 : s.replacement.start
}

export function replaceEnd(s: CelSuggestion): number {
    return s.replacement === null ? -1 : s.replacement.end
}

export function replaceText(s: CelSuggestion): string {
    return s.replacement === null ? s.text : s.replacement.text
}
